<script setup lang="ts">
  import { storeToRefs } from "pinia";
  import { useGridsStore } from "@stores/survey/grids/grids";
  import type { GridSummarySegment } from "@/types";

  defineProps<{ segments: GridSummarySegment[] }>();

  const { populations } = storeToRefs(useGridsStore());

  const populationByToken = (token: string) => populations.value.find((population) => population.token === token);
</script>

<template>
  <template
    v-for="(segment, index) in segments"
    :key="index">
    <span
      v-if="segment.token"
      class="inline-flex items-center gap-1 rounded-full border bg-background px-1.5 py-px align-baseline text-xs font-medium">
      <span
        class="size-2 shrink-0 rounded-full"
        :style="{ backgroundColor: populationByToken(segment.token)?.color ?? undefined }" />
      {{ populationByToken(segment.token)?.name ?? segment.token }}
    </span>
    <template v-else>{{ segment.text }}</template>
  </template>
</template>
